const MIME_PDF = 'application/pdf';
const MIME_XLSX =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const MIME_XLSM = 'application/vnd.ms-excel.sheet.macroEnabled.12';
const MIME_XLS = 'application/vnd.ms-excel';

function baseContentType(response) {
  const h =
    response.headers['content-type'] ||
    response.headers['Content-Type'] ||
    '';
  return h.split(';')[0].trim().toLowerCase();
}

function extensionToMime(ext) {
  const e = (ext || 'pdf').toLowerCase();
  if (e === 'xlsx') return MIME_XLSX;
  if (e === 'xlsm') return MIME_XLSM;
  if (e === 'xls') return MIME_XLS;
  return MIME_PDF;
}

async function sniffBlobType(data, preferredMime) {
  if (!data || typeof data.slice !== 'function') {
    return preferredMime;
  }
  const n = Math.min(4, data.size || 0);
  if (n < 2) {
    return preferredMime;
  }
  const buf = await data.slice(0, n).arrayBuffer();
  const u = new Uint8Array(buf);
  if (
    u.length >= 4 &&
    u[0] === 0x25 &&
    u[1] === 0x50 &&
    u[2] === 0x44 &&
    u[3] === 0x46
  ) {
    return MIME_PDF;
  }
  if (u.length >= 2 && u[0] === 0x50 && u[1] === 0x4b) {
    return MIME_XLSX;
  }
  return preferredMime;
}

export async function blobFromSampleReportResponse(response, extensionGuess) {
  const preferredMime = extensionToMime(extensionGuess);
  const base = baseContentType(response);

  if (base === 'application/json' || base.endsWith('+json')) {
    const text = await response.data.text();
    let message = 'Report could not be downloaded.';
    try {
      const j = JSON.parse(text);
      if (j && j.message) {
        message = j.message;
      }
    } catch (_) {
      /* keep default */
    }
    return { ok: false, message };
  }

  let blobType = preferredMime;
  switch (base) {
    case MIME_PDF:
      blobType = MIME_PDF;
      break;
    case MIME_XLSX:
      blobType = MIME_XLSX;
      break;
    case MIME_XLSM.toLowerCase():
      blobType = MIME_XLSM;
      break;
    case MIME_XLS:
      blobType = MIME_XLS;
      break;
    case 'application/octet-stream':
      blobType = await sniffBlobType(response.data, preferredMime);
      break;
    case '':
      blobType = await sniffBlobType(response.data, preferredMime);
      break;
    default:
      return {
        ok: false,
        message:
          'The report is not available for this study/sample/test. Please explore tests/samples under Asset: Public Data to check the power of this feature.',
      };
  }

  return {
    ok: true,
    blob: new Blob([response.data], { type: blobType }),
  };
}
